module.exports = __webpack_public_path__ + "img/SMS80500-L-min.25ea55f8.png";